export const categoryData = {
  anime: [
    {
      id: 'nagihikari-s1',
      title: '凪光 第一季',
      cover: 'https://readdy.ai/api/search-image?query=Anime%20key%20visual%20of%20a%20young%20male%20protagonist%20with%20wind%20powers%20surrounded%20by%20swirling%20leaves%2C%20warm%20autumn%20color%20palette%2C%20Japanese%20high%20school%20rooftop%20setting%2C%20clean%20anime%20art%20style&width=800&height=450&seq=nagi-cat-anime-01&orientation=landscape',
      rating: 9.6,
      episodes: 24,
      status: '已完结',
      updateDate: '2025-03-15',
      views: 1580000,
      description: '平凡高中生凪在17岁生日那天发现自己拥有操控风的能力，命运的齿轮开始转动……',
      category: '动画番剧',
    },
    {
      id: 'nagihikari-s2',
      title: '凪光 第二季：深海之章',
      cover: 'https://readdy.ai/api/search-image?query=Anime%20visual%20of%20a%20female%20character%20with%20water%20powers%20in%20an%20underwater%20palace%2C%20flowing%20blue%20hair%2C%20surrounded%20by%20bubbles%2C%20fantasy%20anime%20art%20style&width=800&height=450&seq=nagi-cat-anime-02&orientation=landscape',
      rating: 9.8,
      episodes: 24,
      status: '更新至第22话',
      updateDate: '2026-08-10',
      views: 2320000,
      description: '光的身世之谜终于揭开，深海王国的命运与凪息息相关，第二季冒险再升级！',
      category: '动画番剧',
    },
    {
      id: 'nagihikari-s1-sp',
      title: '凪光 第一季 特别篇：风之起源',
      cover: 'https://readdy.ai/api/search-image?query=Anime%20flashback%20scene%20showing%20an%20ancient%20temple%20in%20a%20misty%20forest%2C%20mysterious%20glowing%20wind%20spirits%2C%20soft%20green%20and%20gold%20lighting%2C%20Japanese%20animation%20style%20with%20mythological%20elements&width=800&height=450&seq=nagi-cat-anime-03&orientation=landscape',
      rating: 9.4,
      episodes: 1,
      status: '已完结',
      updateDate: '2025-05-01',
      views: 720000,
      description: '回顾凪获得风之力的起源故事，揭示远古时期风之一族的秘密。',
      category: '动画番剧',
    },
  ],
  movie: [
    {
      id: 'nagihikari-movie',
      title: '凪光 剧场版：永恒之约',
      cover: 'https://readdy.ai/api/search-image?query=Epic%20anime%20movie%20poster%20style%20art%20showing%20two%20characters%20facing%20each%20other%20under%20a%20starlit%20sky%2C%20cherry%20blossoms%20floating%2C%20dramatic%20warm%20lighting%2C%20cinematic%20style&width=800&height=450&seq=nagi-cat-movie-01&orientation=landscape',
      rating: 9.9,
      episodes: 1,
      status: '已上映',
      updateDate: '2026-06-01',
      views: 3850000,
      description: '命运的交织迎来终章，凪与光跨越世纪的约定，将在大银幕上完美呈现。',
      category: '剧场版',
    },
  ],
  ova: [
    {
      id: 'nagihikari-ova1',
      title: '凪光 OVA：夏日的回忆',
      cover: 'https://readdy.ai/api/search-image?query=Anime%20slice%20of%20life%20scene%20showing%20friends%20at%20a%20summer%20festival%2C%20colorful%20fireworks%2C%20traditional%20yukata%2C%20lanterns%2C%20warm%20nostalgic%20atmosphere&width=800&height=450&seq=nagi-cat-ova-01&orientation=landscape',
      rating: 9.3,
      episodes: 2,
      status: '已完结',
      updateDate: '2025-08-20',
      views: 890000,
      description: '暑假期间，凪与伙伴们一起参加夏日祭典，留下了难忘的美好回忆。',
      category: 'OVA特典',
    },
    {
      id: 'nagihikari-ova2',
      title: '凪光 OVA：冬日的约定',
      cover: 'https://readdy.ai/api/search-image?query=Anime%20winter%20scene%20with%20characters%20in%20a%20snowy%20village%2C%20warm%20glowing%20windows%2C%20falling%20snow%2C%20cozy%20atmosphere%2C%20Japanese%20animation%20style%2C%20soft%20lighting&width=800&height=450&seq=nagi-cat-ova-02&orientation=landscape',
      rating: 9.1,
      episodes: 2,
      status: '已完结',
      updateDate: '2026-01-10',
      views: 560000,
      description: '在白雪覆盖的小镇中，凪与光许下了守护彼此的冬日约定。',
      category: 'OVA特典',
    },
  ],
  music: [
    {
      id: 'nagihikari-soundtrack',
      title: '凪光 原声音乐集「风与海之歌」',
      cover: 'https://readdy.ai/api/search-image?query=Beautiful%20music%20album%20cover%20art%20featuring%20a%20grand%20piano%20on%20a%20cliff%20overlooking%20the%20ocean%20at%20sunset%2C%20musical%20notes%20in%20golden%20light%2C%20anime%20art%20style&width=800&height=450&seq=nagi-cat-music-01&orientation=landscape',
      rating: 9.7,
      episodes: 48,
      status: '已发售',
      updateDate: '2026-04-10',
      views: 670000,
      description: '收录两季动画全部原声音乐，由日本顶尖作曲家精心打造。',
      category: '原声音乐',
    },
    {
      id: 'nagihikari-op1',
      title: '凪光 OP主题曲「風の詩」完整版MV',
      cover: 'https://readdy.ai/api/search-image?query=Anime%20music%20visual%20with%20a%20singer%20silhouette%20against%20a%20starry%20night%2C%20swirling%20wind%20effects%2C%20musical%20staff%20lines%20in%20gold%2C%20emotional%20atmosphere%2C%20Japanese%20animation%20art%20style&width=800&height=450&seq=nagi-cat-music-02&orientation=landscape',
      rating: 9.5,
      episodes: 1,
      status: '已发布',
      updateDate: '2025-03-20',
      views: 920000,
      description: '由人气歌手Aoi献唱的第一季片头曲完整版MV，带你重温凪的冒险旅程。',
      category: '原声音乐',
    },
  ],
  news: [
    {
      id: 'nagihikari-news-s3',
      title: '重磅！凪光 第三季制作决定！新视觉图解禁',
      cover: 'https://readdy.ai/api/search-image?query=Anime%20announcement%20visual%20with%20text%20Season%203%20in%20Japanese%20style%2C%20silhouette%20of%20new%20characters%2C%20dramatic%20lighting%2C%20excited%20atmosphere%2C%20professional%20anime%20promotional%20art&width=800&height=450&seq=nagi-cat-news-01&orientation=landscape',
      rating: 0,
      episodes: 0,
      status: '制作中',
      updateDate: '2026-07-10',
      views: 1250000,
      description: '官方正式宣布第三季制作启动，预计2027年播出，全新冒险即将启程。',
      category: '最新资讯',
    },
    {
      id: 'nagihikari-news-interview',
      title: '【特别企划】凪光声优专访：凪役·松本健一访谈',
      cover: 'https://readdy.ai/api/search-image?query=Anime%20voice%20actor%20interview%20setting%2C%20recording%20studio%20with%20microphone%2C%20warm%20atmospheric%20lighting%2C%20professional%20anime%20industry%20scene%2C%20Japanese%20style&width=800&height=450&seq=nagi-cat-news-02&orientation=landscape',
      rating: 0,
      episodes: 0,
      status: '已发布',
      updateDate: '2026-08-08',
      views: 380000,
      description: '为凪配音五年的松本健一首次深度分享角色塑造背后的故事与心路历程。',
      category: '最新资讯',
    },
  ],
  character: [
    {
      id: 'nagihikari-character-guide',
      title: '凪光 角色完全指南',
      cover: 'https://readdy.ai/api/search-image?query=Anime%20character%20lineup%20art%20showing%20six%20diverse%20characters%20from%20a%20fantasy%20series%2C%20each%20with%20unique%20elemental%20powers%2C%20dynamic%20poses%2C%20clean%20anime%20illustration%20style&width=800&height=450&seq=nagi-cat-char-01&orientation=landscape',
      rating: 9.2,
      episodes: 1,
      status: '已发布',
      updateDate: '2026-07-15',
      views: 450000,
      description: '从凪到光，从配角到反派，每一位角色的背景故事与能力设定全解析。',
      category: '角色介绍',
    },
    {
      id: 'nagihikari-character-ryu',
      title: '角色深度解析：龙之继承者·炎真',
      cover: 'https://readdy.ai/api/search-image?query=Anime%20character%20portrait%20of%20a%20red%20haired%20warrior%20with%20flame%20powers%2C%20intense%20expression%2C%20dragon%20tattoo%20on%20arm%2C%20fire%20effects%2C%20dark%20dramatic%20background%2C%20Japanese%20anime%20style&width=800&height=450&seq=nagi-cat-char-02&orientation=landscape',
      rating: 9.0,
      episodes: 1,
      status: '已发布',
      updateDate: '2026-07-18',
      views: 340000,
      description: '作为凪的宿命对手，炎真的火焰之力背后隐藏着怎样的悲剧？全方位解读。',
      category: '角色介绍',
    },
  ],
};

export const allCategoryItems = Object.values(categoryData).flat();